
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev envronment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


export const environment = {
  production: false,

  ///// PRODUCTION
  apiHost: 'https://rmserver.directfn.net',
  // uploadURL: 'https://rmserver.directfn.net/upload',
  downloadURL: 'https://rmserver.directfn.net/download',
  zipDownloadURL: 'https://rmserver.directfn.net/download-zip',

  intranet: 'https://intranet.directfn.net/',
  authApp : 'https://intranet-auth.directfn.net',
  dfnRMApp : 'https://dfnrm.directfn.net/',
};

